<template>
<div>
     <v-dialog
      v-model="dialog1"
      max-width="500"
    >
      <v-card>
       <v-card-title class="headline">Add Product</v-card-title>

        <v-card-text>
            <v-form class='pb-3' ref="form1" v-model="form1"> 
                <v-text-field :rules="[rules.required]" v-model="name" outlined='true' dense="true" label='Name of the Product' ></v-text-field>
                <v-text-field :rules="[rules.required]" v-model="category" outlined='true' dense="true" label='Category of the Product'></v-text-field>
                <v-text-field :rules="[rules.required]" v-model="price" outlined='true' dense="true" label='Price of the Product'></v-text-field>
                <v-text-field :rules="[rules.required]" v-model="units" outlined='true' dense="true" label='Units in stock'></v-text-field>
                <v-file-input :rules="[rules.required]" v-model="images" label="Product Pictures"></v-file-input>
            </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            @click="addProduct"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">Edit Product</v-card-title>

        <v-card-text>
            <v-form class='pb-3' ref="form2" v-model="form2">
                <v-text-field :rules="[rules.required]" v-model="editName" outlined dense label='Name of the Product' ></v-text-field>
                <v-text-field :rules="[rules.required]" v-model="editCategory" outlined dense  label='Category of the Product'></v-text-field>
                <v-text-field :rules="[rules.required]" v-model="editPrice" outlined dense label='Price of the Product'></v-text-field>
                <v-text-field :rules="[rules.required]" v-model="editUnits" outlined dense label='Units in stock'></v-text-field>
                <!-- <v-file-input :rules="[rules.required]" v-model="editImages" label="Product Pictures"></v-file-input> -->
            </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            @click="saveProduct"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>


    
    </v-dialog>


    <v-container>
      <v-row justify="space-between">
         <h1 class='mb-5'>Catalogue</h1>
         <v-btn color='primary' @click.stop="dialog1 = true">Add Product</v-btn>
      </v-row>
      <div v-for='category in categories' :key="category.id">
        <Category :categoryName='category.categoryName' :products='category.products' @onProductEdit="showEditDialog"  @onProductSwitch="saveProductSwitch"/>
      </div>
    </v-container>
</div>
    
</template>

<script>
/*global myBaseURL*/

import axios from 'axios';

import Category from '@/components/Category.vue'

export default {
  name: 'Catalogue',
  components:{
    Category,
  },
  data () {
      return {
        logoutShow:true,
        store_slug : this.$route.params.store_slug,
        name: '',
        category: '',
        price: '',
        units: '',
        images: '',
        form1 : '',
        form2 : '',
        rules:{
            required: value => !!value || 'Required.',
            counter: value => value.length <= 25 || 'Max 25 characters',
        },
        dialog1:false,
        editDialog:false,
        editId: 0,
        editName: '',
        editCategory: '',
        editPrice: '',
        editUnits: '',
        editImages: '',
        editInStock: '',
        editDialogData:{
          // productName:"ProductFoo",
          // productCategory:"ProductCat",
          // productPrice:"1234",
          // productUnits:"5678",
        },
        
        categories: []
        
      }
    },
    beforeRouteUpdate (to, from, next) {
      var that = this;
      axios.request({
          url: '/products/' + to.params.store_slug,
          method: 'GET',
          baseURL: myBaseURL,
          headers: {
              'Authorization': 'Bearer '+ window.localStorage.access_token
          }
      }).then(response => {
          that.categories = response.data.categories;
          that.store_slug = to.params.store_slug;
          console.log('Success Data')
      }).catch(e => {
          console.log(e);
          console.log('Fail Data')
      });
      next()
    },
    created(){
        var that = this;
        this.$emit('showLogout',true);
        this.$emit('showNavDrawer',true);
        axios.request({
            url: '/me/store' ,
            method: 'GET',
            baseURL: myBaseURL,
            headers: {
                'Authorization': 'Bearer '+ window.localStorage.access_token
            }
        }).then(response => {
            if(that.store_slug != response.data.store_slug)
            {
              this.$router.replace({ name: 'ControlPanel', params : {store_slug : response.data.store_slug} })
            }
            else
            {
              axios.request({
                  url: '/products/' + that.store_slug,
                  method: 'GET',
                  baseURL: myBaseURL,
                  headers: {
                      'Authorization': 'Bearer '+ window.localStorage.access_token
                  }
              }).then(response => {
                  console.log(response.data);
                  that.categories = response.data.categories;
                  console.log('Success Data')
              }).catch(e => {
                  console.log(e);
                  console.log('Fail Data')
              });
            }
        }).catch(e => {
            console.log(e);
            console.log('Fail Data')
        });
    },
    methods:{
      showEditDialog(newData){
        console.log(newData);
        this.editDialog=newData.editDialog
        this.editId = newData.productId
        this.editName=newData.productName
        this.editCategory=newData.productCategory
        this.editUnits = newData.productUnits
        this.editPrice=newData.productPrice
        this.editInStock = newData.productInStock
        // this.editImages = newData.productImage
      },
      saveProductSwitch(newData)
      {
          console.log(newData);
          var that = this;
          axios.request({
              url: '/product/' + that.store_slug + '/' + newData.productId,
              method: 'PUT',
              baseURL: myBaseURL,
              headers: {
                  'Authorization': 'Bearer '+ window.localStorage.access_token
              },
              data : {
                  'in_stock' : newData.inStock
              }
          }).then(response => {
              console.log(response.data);
              that.categories = response.data.data.categories;
              console.log('Success Data')
          }).catch(e => {
              console.log(e);
              console.log('Fail Data')
          });
      },
      saveProduct(){
          if(this.$refs.form2.validate())
          {
              var that = this;
              console.log(window.localStorage.access_token);
              var formData = new FormData();
              formData.append('name',that.editName);
              formData.append('category',that.editCategory);
              formData.append('price',that.editPrice);
              formData.append('units',that.editUnits);
              // formData.append('images',that.editImages);
              // formData.append('in_stock',that.editInStock);

              console.log(formData);

              axios.put( myBaseURL + '/product/' + that.store_slug + '/' + that.editId,
                  formData,
                  {
                      headers: {
                          'Content-Type': 'multipart/form-data',
                          'Authorization': 'Bearer '+ window.localStorage.access_token
                      }
                  }
              ).then(response => {
                  console.log(response.data);
                  that.editDialog = false
                  that.categories = response.data.data.categories;
                  // that.$router.push({ path: '/controlpanel' });
                  console.log('Submit Success')
              }).catch(e => {
                  console.log(e);
                  console.log('Submit Fail')
              });
          }
      },
      addProduct(){
          if(this.$refs.form1.validate())
          {
              var that = this;
              console.log(window.localStorage.access_token);
              var formData = new FormData();
              formData.append('name',that.name);
              formData.append('category',that.category);
              formData.append('price',that.price);
              formData.append('units',that.units);
              formData.append('store_slug',that.store_slug);
              formData.append('images',that.images);

              axios.post( myBaseURL + '/product',
                  formData,
                  {
                      headers: {
                          'Content-Type': 'multipart/form-data',
                          'Authorization': 'Bearer '+ window.localStorage.access_token
                      }
                  }
              ).then(response => {
                  console.log(response.data);
                  that.dialog1 = false;
                  that.categories = response.data.data.categories;
                  // that.$router.push({ path: '/controlpanel' });
                  console.log('Submit Success')
              }).catch(e => {
                  console.log(e);
                  console.log('Submit Fail')
              });
          }
      }
    }

}
</script>
  